import { collectScene } from "../../_editor/components/clipboard/clipboard.utils";
import { ID_PREFIX_SECTION } from "../../common/constants";

// Scene ids in course order (sections hold no content).
export const sceneIds = (state) =>
  (state.navItemsIds || []).filter((id) => String(id).indexOf(ID_PREFIX_SECTION) !== 0);

// Name the editor shows for a scene (viewName), fallback "Sahne N".
export const sceneName = (state, id) =>
  ((state.viewToolbarsById || {})[id] || {}).viewName ||
  "Sahne " + (sceneIds(state).indexOf(id) + 1);

// Scenes for the export picker, plus the one to pre-select: the scene open in
// the editor, else the first scene.
export const sceneChoices = (state) => {
  const ids = sceneIds(state);
  return {
    scenes: ids.map((id, i) => ({ id, name: sceneName(state, id), index: i + 1 })),
    defaultId: ids.includes(state.navItemSelected) ? state.navItemSelected : ids[0] || "",
  };
};

// Copy of the course state holding only one scene (plus its parent chain),
// so the regular SCORM builder can export it unchanged.
// ponytail: links to other scenes and nested boxes of contained views are not followed.
export function buildSceneState(state, sceneId) {
  const scene = collectScene(sceneId, state);
  const keep = new Set([String(sceneId), "0"]);
  for (let p = state.navItemsById[sceneId].parent; p && state.navItemsById[p]; ) {
    keep.add(String(p));
    p = state.navItemsById[p].parent;
  }

  const navItemsById = {};
  Object.keys(state.navItemsById).forEach((id) => {
    if (!keep.has(id)) return;
    const n = state.navItemsById[id];
    navItemsById[id] = { ...n, children: (n.children || []).filter((c) => keep.has(String(c))) };
  });

  const boxesById = { ...scene.boxes };
  const pluginToolbarsById = { ...scene.toolbars };
  const containedViewsById = {};
  Object.keys(scene.containedViews).forEach((cvId) => {
    const cv = scene.containedViews[cvId];
    containedViewsById[cvId] = cv.navItem;
    Object.assign(boxesById, cv.boxes);
    Object.assign(pluginToolbarsById, cv.toolbars);
  });

  const viewToolbarsById = {};
  Object.keys(state.viewToolbarsById || {}).forEach((id) => {
    if (keep.has(id)) viewToolbarsById[id] = state.viewToolbarsById[id];
  });

  const gc = state.globalConfig;
  return {
    ...state,
    navItemsIds: state.navItemsIds.filter((id) => keep.has(String(id))),
    navItemsById,
    boxesById,
    pluginToolbarsById,
    containedViewsById,
    marksById: scene.marks,
    viewToolbarsById,
    exercises: scene.exercises ? { [sceneId]: scene.exercises } : {},
    soundList: { [sceneId]: scene.soundList },
    animationsById: scene.animations,
    globalConfig: {
      ...gc,
      title: `${gc.title} – ${sceneName(state, sceneId)}`,
      scormIdentifier: `com.idealStudio.presentation.${sceneId}`,
    },
  };
}
